export const T = {
  en: {
    appName: 'ReadBuddy',
    tagline: 'Padhna Seekho, Apni Speed Se',
    signInGoogle: 'Sign in with Google',
    parents: 'For parents/guardians',
    kids: 'Class 1 through 10',
    chooseProfile: 'Who is reading today?',
    addChild: 'Add a profile',
    newChild: 'New profile',
    name: 'Name',
    dob: 'Date of birth',
    languages: 'Reading languages',
    save: 'Save', cancel: 'Cancel',
    home: 'Home', books: 'Books', dashboard: 'Dashboard', profile: 'Profile',
    continueReading: 'Continue reading',
    quickPractice: 'Quick practice',
    startReading: 'Start reading',
    addBook: 'Add a new book',
    quickCapture: 'Quick single page',
    noBooks: 'No books yet. Tap "Add a new book" to snap textbook pages.',
    capturePages: 'Capture book pages',
    takePhoto: 'Take a photo',
    uploadPhoto: 'Choose photo',
    extractingText: 'Reading the page…',
    reviewPages: 'Review pages',
    reorder: 'Drag to reorder',
    bookTitle: 'Book title',
    saveBook: 'Save book',
    readToMe: 'Read to me',
    yourTurn: 'Your turn — tap the mic',
    stopMic: 'Stop', scoring: 'Scoring…',
    accuracy: 'Accuracy', points: 'Points',
    totalStars: 'Total stars', streak: 'Day streak',
    tryAgain: 'Try again', nextChunk: 'Next Chunk', prevChunk: 'Previous Chunk',
    todayActivity: 'Today', weekActivity: 'This week',
    missedWords: 'Words to practise',
    rewards: 'Reward goals',
    addReward: 'Add reward', rewardTitle: 'Reward name', rewardTarget: 'Points needed',
    logout: 'Log out', switchProfile: 'Switch profile',
    great: 'Great', good: 'Good', needsPractice: 'Needs practice',
    sessions: 'Sessions', editText: 'Edit text', retake: 'Retake', delete: 'Delete',
    readingSpeed: 'Reading speed', verySlow: 'Very slow', slow: 'Slow', normal: 'Normal', fast: 'Fast',
    practiceWords: 'Practice these words', tapToHear: 'Tap a word to hear it',
    viewPage: 'View page', viewText: 'View text',
    fromGallery: 'From gallery', fromCamera: 'From camera', cropAdjust: 'Crop & adjust',
    bookmark: 'Bookmark',
    lastReadHere: 'You stopped here last time',
    continueFromHere: 'Continue from here',
    pageProgress: 'Page {p} of {t}',
    startBook: 'Start book', welcomeBack: 'Welcome back!',
    voice: 'Reading voice', voiceFemale: 'Female (warm)', voiceMale: 'Male (warm)',
    customAvatar: 'Upload photo',
    playMyReading: "Hear what I said", playCorrect: 'Hear correct',
    doneForToday: 'Done for today',
    summarize: 'Summarise the chunk',
    meaning: 'Meaning?',
    coachRepeat: 'Try that word again:', coachDone: 'Well done! Nice!',
    chunkSize: 'Chunk size',
    short: 'Short', medium: 'Medium', long: 'Long',
    trendTitle: 'How you\'re growing',
    deleteHistory: 'Delete session history',
    deleteHistoryConfirm: 'Delete ALL previous sessions? This cannot be undone.',
    parentVoice: 'Parent/Guardian voice (optional)',
    recordSample: 'Record 20-30s sample',
    stopRecording: 'Stop', consentTitle: 'Consent required',
    consentText: "I confirm this is my own voice and I authorize its use for my student's reading practice within ReadBuddy.",
    iAgree: 'I agree & save voice', deleteVoice: 'Remove voice',
    privacy: 'Data & privacy',
    privacyBody: "All your students' sessions, recordings, points, and any cloned voice are stored only under your parent/guardian account. Only you (this signed-in Google account) can view or use this data. Cloned voice files stay tied to your account and are never shared with other users.",
  },
};

// UI is always English. The `hi` block is intentionally removed — Hindi
// appears only inside actual lesson content (book text, TTS narration,
// meanings, summaries, coach corrections).
export const useT = (_uiLang) => (key) => T.en[key] ?? key;
